<template>
  <div class="sf-el html-item">
    <div class="sf-html">
      <div v-html="content"></div>
    </div>
  </div>
</template>

<script>
  import { watch, ref } from 'vue';
  export default {
    name: 'HtmlElement',
    props: {
      content: String,
    },
    setup(props, { emit }) {
      const content = ref(props.content);
      return { content };
    },
  };
</script>

<style scoped lang="scss">
  .sf-html {
    a {
      text-decoration: underline;
      color: var(--cs-link-color);
    }
  }
</style>
